// Dashboard
import Dashboard from "../Pages/Dashboard/Index";
import EcomDash from "../Pages/EcomDash/Index";
import ProjectDash from "../Pages/ProjectDash/Index";

// Apps
import EmailPage from "../Pages/Apps/Email/Index";
import ChatPage from "../Pages/Apps/Chat/Index";
import ContactPage from "../Pages/Apps/Contact/Index";
import InvoicePage from "../Pages/Apps/Invoice/Index";
import CalendarPage from "../Pages/Apps/Calendar/Index";

// Components
import Tabs from "../Pages/Ui-Kit/Components/Tabs";
import AccordionsPage from "../Pages/Ui-Kit/Components/Accordions";
import Modals from "../Pages/Ui-Kit/Components/Modals";
import CopyToClipBoard from "../Pages/Ui-Kit/Components/CopyToClipBoard";
import Notification from "../Pages/Ui-Kit/Components/Notification";
import CarouselPage from "../Pages/Ui-Kit/Components/Carousel";
import Pricing from "../Pages/Ui-Kit/Components/Pricing";
import LightboxPage from "../Pages/Ui-Kit/Components/Lightbox";
import CountdownPage from "../Pages/Ui-Kit/Components/Countdown";
import CounterPage from "../Pages/Ui-Kit/Components/Counter";

// Elements
import AllAlert from "../Pages/Ui-Kit/Ui-Element/Alert";
import Buttons from "../Pages/Ui-Kit/Ui-Element/Buttons";
import ButtonsGroup from "../Pages/Ui-Kit/Ui-Element/ButtonsGroup";
import Badges from "../Pages/Ui-Kit/Ui-Element/Badges";
import Breadcrumb from "../Pages/Ui-Kit/Ui-Element/Breadcrumb";
import DropdownPage from "../Pages/Ui-Kit/Ui-Element/Dropdown";
import Videos from "../Pages/Ui-Kit/Ui-Element/Videos";
import Images from "../Pages/Ui-Kit/Ui-Element/Images";
import Typography from "../Pages/Ui-Kit/Ui-Element/Typography";
import Avatar from "../Pages/Ui-Kit/Ui-Element/Avatar";
import Tooltips from "../Pages/Ui-Kit/Ui-Element/Tooltips";
import LoaderPage from "../Pages/Ui-Kit/Ui-Element/Loader";
import PaginationPage from "../Pages/Ui-Kit/Ui-Element/Pagination";
import ProgressbarPage from "../Pages/Ui-Kit/Ui-Element/Progressbar";

import ChartPage from "../Pages/Charts/Chart";

import Icons from "../Pages/Icon/Icons";

// Forms
import BasicForm from "../Pages/Forms/BasicForm";
import InputGroup from "../Pages/Forms/InputGroup";
import Editors from "../Pages/Forms/Editors";
import Validation from "../Pages/Forms/Validation";
import Checkbox from "../Pages/Forms/Checkbox";
import Radio from "../Pages/Forms/Radio";
import Switches from "../Pages/Forms/Switches";

// table
import BasicTable from "../Pages/Table/BasicTable/Index";
import Datatables from "../Pages/Table/DataTable/Index";
import EdiTable from "../Pages/Table/Editable/Index";

// users
import Profile from "../Pages/Users/Profile";
import Settings from "../Pages/Users/Settings";

// pages
import Blank from "../Pages/Page/Blank";
import Maintenance from "../Pages/Page/Maintenance";
import ComingSoon from "../Pages/Page/ComingSoon";
import Error404 from "../Pages/Page/404";
import Error500 from "../Pages/Page/500";
import Error503 from "../Pages/Page/503";

// Authentication
import AuthLogin from "../Pages/AuthPages/AuthLogin";
import AuthSignup from "../Pages/AuthPages/AuthSignup";
import ResetPw from "../Pages/AuthPages/ResetPw";

// Auth-Inner
import Login from "../Pages/Authentication/Login";
import Register from "../Pages/Authentication/Register";
import Logout from "../Pages/Authentication/Logout";
import FlatPickr from "../Pages/Ui-Kit/Components/FlatPickr";

const allRoutes = [
  { path: "/", component: <Dashboard /> },
  
  // Dashboard
  { path: "/index", component: <Dashboard /> },
  { path: "/project-dashboard", component: <ProjectDash /> },
  { path: "/ecommerce-dashboard", component: <EcomDash /> },

  // Apps
  { path: "/email", component: <EmailPage /> },
  { path: "/chat", component: <ChatPage /> },
  { path: "/contact", component: <ContactPage /> },
  { path: "/invoice", component: <InvoicePage /> },
  { path: "/calendar", component: <CalendarPage /> },

  // Components
  { path: "/ui-tabs", component: <Tabs /> },
  { path: "/ui-accordions", component: <AccordionsPage /> },
  { path: "/ui-modals", component: <Modals /> },
  { path: "/ui-clipboard", component: <CopyToClipBoard /> },
  { path: "/ui-notification", component: <Notification /> },
  { path: "/ui-carousel", component: <CarouselPage /> },
  { path: "/ui-pricing", component: <Pricing /> },
  { path: "/ui-lightbox", component: <LightboxPage /> },
  { path: "/ui-countdown", component: <CountdownPage /> },
  { path: "/ui-counter", component: <CounterPage /> },
  {  path: "/ui-flatpickr", component: <FlatPickr /> },

  // Elements
  { path: "/ui-alerts", component: <AllAlert /> },
  { path: "/ui-buttons", component: <Buttons /> },
  { path: "/ui-buttons-group", component: <ButtonsGroup /> },
  { path: "/ui-badge", component: <Badges /> },
  { path: "/ui-breadcrumb", component: <Breadcrumb /> },
  { path: "/ui-videos", component: <Videos /> },
  { path: "/ui-images", component: <Images /> },
  { path: "/ui-dropdowns", component: <DropdownPage /> },
  { path: "/ui-typography", component: <Typography /> },
  { path: "/ui-avatar", component: <Avatar /> },
  { path: "/ui-tooltips", component: <Tooltips /> },
  { path: "/ui-loader", component: <LoaderPage /> },
  { path: "/ui-pagination", component: <PaginationPage /> },
  { path: "/ui-progress-bar", component: <ProgressbarPage /> },

  // chart
  { path: "/chart", component: <ChartPage /> },

  // icon
  { path: "/icons", component: <Icons /> },

  // Forms
  { path: "/forms-basic", component: <BasicForm /> },
  { path: "/forms-input-group", component: <InputGroup /> },
  { path: "/forms-editors", component: <Editors /> },
  { path: "/validation", component: <Validation /> },
  { path: "/checkbox", component: <Checkbox /> },
  { path: "/forms-radio", component: <Radio /> },
  { path: "/switches", component: <Switches /> },

  // Table
  { path: "/tables-basic", component: <BasicTable /> },
  { path: "/tables-datatables", component: <Datatables /> },
  { path: "/tables-editable", component: <EdiTable /> },

  // users
  { path: "/pages-users-profile", component: <Profile /> },
  { path: "/pages-users-settings", component: <Settings /> },

  // pages
  { path: "/blank", component: <Blank /> },
];

const authRoutes = [
    
    // Authentication
    { path: "/login", component: <AuthLogin /> },
    { path: "/signup", component: <AuthSignup /> },
    { path: "/reset-pw", component: <ResetPw /> },

    // Working Authentication
    { path: "/auth-login", component: <Login /> },
    { path: "/auth-register", component: <Register /> },
    { path: "/auth-logout", component: <Logout /> },

];

const pagesRoutes = [
    // pages
    { path: "/pages-maintenance", component: <Maintenance /> },
    { path: "/pages-coming-soon", component: <ComingSoon /> },
    { path: "/pages-404", component: <Error404 /> },
    { path: "/pages-500", component: <Error500 /> },
    { path: "/pages-503", component: <Error503 /> },
    
]

export { allRoutes, authRoutes, pagesRoutes };
